module.exports = __webpack_public_path__ + "static/media/quiz-saphir.aa2b63a4.png";